export var IconSensorTypeId;
(function (IconSensorTypeId) {
    IconSensorTypeId["TEMPERATURE"] = "TEMPERATURE";
    IconSensorTypeId["HUMIDITY"] = "HUMIDITY";
    IconSensorTypeId["BINARY"] = "BINARY";
    IconSensorTypeId["AMBIENT"] = "AMBIENT";
    IconSensorTypeId["ENERGY"] = "ENERGY";
})(IconSensorTypeId || (IconSensorTypeId = {}));
